import { AirconCityHub } from '../../../components/market/AirconCityHub'
import { getAirconPageProps } from '../../../lib/market-pages'
import content from '../../../data/markets/my/aircon/kuala-lumpur/hub'

// Bump by hand when the copy changes (feeds dateModified).
const CONTENT_REVIEWED = '2026-10-03'

export const getStaticProps = () => getAirconPageProps('my', 'kuala-lumpur', CONTENT_REVIEWED)

export default function Page(props) {
    return <AirconCityHub {...props} content={content} />
}
